module.exports = __webpack_public_path__ + "static/img/callback1.5b94bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callback/callback1.png
// module id = W38l
// module chunks = 0